import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue } from 'redux-form';
import selecionarAgencia from '../../actions/agencia/selecionarAgencia';
import alterarExibicaoDetalhamentoAgencia from '../../actions/agencia/alterarExibicaoDetalhamentoAgencia';
import DetalheAgencia from './DetalheAgencia';


export class Agencia extends React.Component {
  selecionarAgencia (agencia) {
    this.props.changeFieldValue('formularioCadastrarCidade', 'logradouro', agencia.logradouro);
    this.props.changeFieldValue('formularioCadastrarCidade', 'complemento', agencia.complemento);
    this.props.changeFieldValue('formularioCadastrarCidade', 'bairro', agencia.bairro);
    this.props.changeFieldValue('formularioCadastrarCidade', 'localidade', agencia.localidade);
    this.props.changeFieldValue('formularioCadastrarCidade', 'uf', agencia.uf);
    this.props.changeFieldValue('formularioCadastrarCidade', 'cep', agencia.cep);
    this.props.changeFieldValue('formularioCadastrarCidade', 'idAgencia', agencia.id);
    this.props.changeFieldValue('formularioCadastrarCidade', 'nome', agencia.nome);
    this.props.changeFieldValue('formularioCadastrarCidade', 'numero', agencia.numero);
    this.props.changeFieldValue('formularioCadastrarCidade', 'cnpj', agencia.cnpj);
    this.props.changeFieldValue('formularioCadastrarCidade', 'inscricaoEstadual', agencia.inscricaoEstadual);
  }

  render () {
    const ag = this.props.agencia;
    return (
      <div className="vx-row-item">
        <div className="vx-row-item-inner vx-row-item-inner--agencia">
          <div className="vx-row-cell">
            <button
              className="vx-row-expand-btn"
              onClick={() => this.props.alterarExibicaoDetalhamentoAgencia(ag)}>
              <span className="material-icons">{ag.exibirConteudo ? 'expand_less' : 'expand_more'}</span>
            </button>
          </div>
          <div className="vx-row-cell">
            <span className="vx-row-cell-label">Número</span>
            {ag.id}
          </div>
          <div className="vx-row-cell">
            <span className="vx-row-cell-label">Nome</span>
            {ag.nome}
          </div>
          <div className="vx-row-cell">
            <span className="vx-row-cell-label">CNPJ</span>
            {ag.cnpj}
          </div>
          <div className="vx-row-cell">
            <span className="vx-row-cell-label">Localidade</span>
            {ag.localidade}
          </div>
          <div className="vx-row-cell">
            <span className="vx-row-cell-label">UF</span>
            {ag.uf}
          </div>
          <div className="vx-row-cell">
            <span className="vx-row-cell-label">Logradouro</span>
            {ag.logradouro}
          </div>
          <div className="vx-row-cell">
            <span className="vx-row-cell-label">Bairro</span>
            {ag.bairro}
          </div>
          <div className="vx-row-cell">
            <span className="vx-row-cell-label">CEP</span>
            {ag.cep}
          </div>
          <div className="vx-row-cell">
            <span className="vx-row-cell-label">Ações</span>
            <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
              <button type="button" className="vx-act-btn vx-act-btn--delete"
                title="Excluir agência"
                data-toggle="modal"
                data-target="#modalConfirmacaoExclusaoAgencia"
                onClick={() => this.props.selecionarAgencia(ag)}>
                <span className="material-icons">delete</span>
              </button>
              <button type="button" className="vx-act-btn vx-act-btn--edit"
                title="Editar agência"
                data-toggle="modal"
                data-target="#modalCadastrarAgencia"
                onClick={() => {
                  this.props.selecionarAgencia(ag);
                  this.selecionarAgencia(ag);
                }}>
                <span className="material-icons">edit</span>
              </button>
              <button type="button" className="vx-act-btn vx-act-btn--lock"
                title={ag.bloqueada ? 'Desbloquear agência' : 'Bloquear agência'}
                data-toggle="modal"
                data-target="#modalConfirmacaoBloqueioAgencia"
                onClick={() => this.props.selecionarAgencia(ag)}>
                <span className="material-icons">{ag.bloqueada ? 'lock' : 'lock_open'}</span>
              </button>
            </div>
          </div>
        </div>
        <DetalheAgencia agencia={ag} />
      </div>
    )
  }
}

export function mapStateToProps () {
  return {}
}

export default connect(mapStateToProps, {
  selecionarAgencia,
  alterarExibicaoDetalhamentoAgencia,
  changeFieldValue
})(Agencia)
